module.exports = __webpack_public_path__ + "static/media/stk_logo_build_service_button@3x@3x.41065cbb.png";